import { createContext } from "react";
import PropTypes from 'prop-types';


export const FibConfigContext = createContext()

export default function FibConfigProvider(props) {
    const { children, ...config } = props

    return (
        <FibConfigContext.Provider value={config}>
            {children}
        </FibConfigContext.Provider>
    )
}

FibConfigProvider.propTypes = {
    children: PropTypes.node,
}